import type { OAISchema } from '~/types/openapi';

export const SHOPPING_CART = 'SHOPPING_CART';
export const QUICK = 'QUICK';

export type CART_TYPE =
  OAISchema['MarketPaymentRequestAuthRequest']['cartType'];
